import Vue from 'vue'
import Invite from './Index'
const InviteConstructor = Vue.extend(Invite)
let vm = null
let instance = null
let instanceIndex = 0
const InviteInstance = function (options) {
  const box = 'invite-out__wrapper'
  const boxId = box + '-' + instanceIndex
  options = options || {}
  options.boxId = boxId
  // options.isShow = true
  document.body.style.overflow = 'hidden'
  if (!vm) {
    const div = document.createElement('div')
    div.className = box
    div.id = boxId
    document.body.appendChild(div)
    vm = new Vue({
      el: div
    })
    instanceIndex++
  }
  options.onInstanceClose = (boxId) => {
    InviteInstance.close(boxId)
  }
  instance = new InviteConstructor({
    data: options
  })
  instance.vm = instance.$mount()
  vm.$el.appendChild(instance.vm.$el)
  instance.dom = instance.vm.$el
  return instance.vm
}

InviteInstance.close = (id) => {
  if (id) {
    const element = document.getElementById(id)
    if (element) {
      element.parentNode.removeChild(element)
    }
    vm = null
    document.body.style.overflow = ''
  }
}

export default InviteInstance
